var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import gql from "graphql-tag";
export default (function (emailAddress) { return ({
    mutation: gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    mutation forgotPasswordMutation($emailAddress: String!) {\n      forgotPassword(emailAddress: $emailAddress) {\n        ok\n      }\n    }\n  "], ["\n    mutation forgotPasswordMutation($emailAddress: String!) {\n      forgotPassword(emailAddress: $emailAddress) {\n        ok\n      }\n    }\n  "]))),
    variables: { emailAddress: emailAddress },
}); });
var templateObject_1;
